import { pricingConfigurationApi } from 'app/services/api';

import { PpeType } from 'constants/company';
import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectIsBrokerCompany } from 'store/auth/selectors';

export const PRICING_CONFIGURATION_ACTION_TYPE = createNamedActions('pricingConfiguration', {
  GET_CONFIGURATION: 'GET_CONFIGURATION',
  EDIT_CONFIGURATION: 'EDIT_CONFIGURATION',
  CREATE_CONFIGURATION: 'CREATE_CONFIGURATION',
});

const getPricingConfigurationAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await pricingConfigurationApi.getConfiguration();

  return dispatch({
    type: PRICING_CONFIGURATION_ACTION_TYPE.GET_CONFIGURATION,
    payload: data,
  });
});

export const editPricingConfigurationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await pricingConfigurationApi.editConfiguration(params);

  return dispatch({
    type: PRICING_CONFIGURATION_ACTION_TYPE.EDIT_CONFIGURATION,
    payload: data,
  });
});

const createPricingConfigurationAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await pricingConfigurationApi.createConfiguration(params);

  return dispatch({
    type: PRICING_CONFIGURATION_ACTION_TYPE.CREATE_CONFIGURATION,
    payload: data,
  });
});

export const getAndCreateOnErrorPricingConfigurationAction = catchAsyncActionError(
  () => async (dispatch, getState) => {
    const state = getState();
    const isBrokerCompany = selectIsBrokerCompany(state);
    const defaultParams = {
      ppeType: isBrokerCompany ? PpeType.OPTIMAL_BLUE_PPE : PpeType.LENDER_PPE,
    };

    try {
      await dispatch(getPricingConfigurationAction());
    } catch (error) {
      const { response } = error;

      const isConfigurationNotFoundErrorResponse =
        response?.status === HTTP_RESPONSE_STATUS_CODES.NOT_FOUND;

      if (isConfigurationNotFoundErrorResponse) {
        await dispatch(createPricingConfigurationAction(defaultParams));
      }
    }
  },
);
